import {Link} from "react-router-dom";
import {LogIn} from "lucide-react";
import {LOGO_ON_WHITE} from "@/lib/inner";

const logout = () => {
  localStorage.removeItem("inner_token");
  localStorage.removeItem("inner_user");
  window.location.href = "/staff";
};

export const SiteHeader = ({staff = false}) => (
  <header className="topbar">
    <Link className="brand" to="/" data-testid="brand-home-link"><img src={LOGO_ON_WHITE} alt="INNER Salon Muslimah"/></Link>
    <nav>
      {staff ? <>
        <Link data-testid="dashboard-nav" to="/dashboard">Jadwal Hari Ini</Link>
        <Link data-testid="settings-nav" to="/dashboard/settings">Pengaturan</Link>
      </> : <>
        <a href="/#outlet" data-testid="nav-outlet-link">Outlet</a>
        <a href="/#cara" data-testid="nav-steps-link">Cara Booking</a>
        <Link className="nav-cta" data-testid="header-booking-button" to="/booking">Booking Perawatan</Link>
      </>}
    </nav>
    {staff && <button className="icon-button" data-testid="staff-logout-button" onClick={logout}><LogIn size={17}/> Keluar</button>}
  </header>
);
